import { render } from "./gameComponent.vue?vue&type=template&id=7718c78e&scoped=true"
import script from "./gameComponent.vue?vue&type=script&lang=js"
export * from "./gameComponent.vue?vue&type=script&lang=js"

import "./gameComponent.vue?vue&type=style&index=0&id=7718c78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7718c78e"]])

export default __exports__